module.exports = __webpack_public_path__ + "assets/img/driver-btn-8cf8f63e.png";